if (!window.Maximize.loadedScript.includes("speech-search.js")) {
  window.Maximize.loadedScript.push("speech-search.js");

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xSpeechSearch", (el, initialLanguage = "", initialLanguageLabel = "") => ({
        recognition: null,
        isListening: false,
        searchInput: null,
        searchBtn: null,
        speechButton: null,
        show: false,
        speechLanguage: initialLanguage || (document.documentElement.lang?.toLowerCase().startsWith("ar") ? "ar-IQ" : "en-US"),
        speechLanguageLabel: initialLanguageLabel || (document.documentElement.lang?.toLowerCase().startsWith("ar") ? "AR" : "EN"),

        init() {
          const SpeechRecognition =
            window.SpeechRecognition || window.webkitSpeechRecognition;

          if (SpeechRecognition) {
            this.show = true;
            this.recognition = new SpeechRecognition();
            this.recognition.continuous = false;
            this.recognition.interimResults = true;
            this.recognition.lang = this.speechLanguage;

            const form = el.closest("form");
            this.searchInput = form.querySelector(".input-search");
            this.searchBtn = form.querySelector(".btn-search");
            this.speechButton = el.matches(".search__speech") ? el : el.querySelector(".search__speech");
            this.bindEvents();
          } else {
            this.show = false;
          }
        },

        bindEvents() {
          this.recognition.addEventListener("result", (evt) => {
            if (evt.results) {
              const term = evt.results[0][0].transcript;
              this.searchInput.value = term;
              this.searchInput.dispatchEvent(new Event("input", { bubbles: true }));
              this.speechButton?.blur();
              this.searchBtn.focus();
            }
          });

          this.recognition.addEventListener("audiostart", () => {
            this.isListening = true;
            this.speechButton?.classList.add("search__speech-listening");
          });

          this.recognition.addEventListener("audioend", () => {
            this.isListening = false;
            this.speechButton?.classList.remove("search__speech-listening");
          });

          this.recognition.addEventListener("error", (evt) => {
            console.warn("SpeechRecognition error:", evt.error);
            this.isListening = false;
            this.speechButton?.classList.remove("search__speech-listening");
          });

          if (el.matches(".search__speech")) {
            el.addEventListener("click", (event) => this.toggleListen(event));
          }
        },

        toggleLanguage() {
          if (this.isListening) this.recognition.stop();
          const useArabic = this.speechLanguageLabel !== "AR";
          this.speechLanguage = useArabic ? "ar-IQ" : "en-US";
          this.speechLanguageLabel = useArabic ? "AR" : "EN";
          if (this.recognition) this.recognition.lang = this.speechLanguage;
        },

        toggleListen(evt) {
          evt.preventDefault();
          if (this.isListening) {
            this.recognition.stop();
          } else {
            this.recognition.lang = this.speechLanguage;
            this.recognition.start();
          }
        },
      }));
    });
  });
}
